(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.messages = Array.from(this.querySelectorAll('.announcement__message'));
      if (!this.messages.length) return;
      this.mql = window.matchMedia('(max-width: 749px)');
      this.autoplay = this.dataset.autoplay === 'true';
      this.pauseHover = this.dataset.pauseHover === 'true';
      this.interval = parseInt(this.dataset.speed, 10) || 5000;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        || document.body.classList.contains('animations-off');

      this.showFirst();

      this.bindArrow('[data-ann-prev]', -1);
      this.bindArrow('[data-ann-next]', 1);

      if (this.autoplay && !this.reduceMotion) {
        this.start();
        if (this.pauseHover) {
          this._onEnter = () => this.stop();
          this._onLeave = () => this.start();
          this.addEventListener('mouseenter', this._onEnter);
          this.addEventListener('mouseleave', this._onLeave);
          this.addEventListener('focusin', this._onEnter);
          this.addEventListener('focusout', this._onLeave);
        }
      }

      // Keep the active message valid when the viewport crosses the breakpoint.
      this._onMqlChange = () => this.ensureVisible();
      this.mql.addEventListener('change', this._onMqlChange);

      // Theme editor: reveal the selected message and pause rotation while editing.
      this._onBlockSelect = (e) => {
        const msg = e.target.closest && e.target.closest('.announcement__message');
        if (msg) { this.setActive(msg); this.stop(); }
      };
      this._onBlockDeselect = () => {
        if (this.autoplay && !this.reduceMotion) this.start();
      };
      this.addEventListener('shopify:block:select', this._onBlockSelect);
      this.addEventListener('shopify:block:deselect', this._onBlockDeselect);
    }
    disconnectedCallback() {
      this.stop();
      if (this._onMqlChange) this.mql.removeEventListener('change', this._onMqlChange);
      if (this._onEnter) {
        this.removeEventListener('mouseenter', this._onEnter);
        this.removeEventListener('mouseleave', this._onLeave);
        this.removeEventListener('focusin', this._onEnter);
        this.removeEventListener('focusout', this._onLeave);
      }
    }
    isVisible(msg) {
      const v = msg.getAttribute('data-visibility') || 'all';
      const mobile = this.mql.matches;
      if (v === 'desktop') return !mobile;
      if (v === 'mobile') return mobile;
      return true;
    }
    visibleMessages() {
      return this.messages.filter((m) => this.isVisible(m));
    }
    setActive(msg) {
      this.messages.forEach((m) => m.classList.toggle('is-active', m === msg));
    }
    showFirst() {
      const list = this.visibleMessages();
      if (list.length) this.setActive(list[0]);
    }
    ensureVisible() {
      const active = this.messages.find((m) => m.classList.contains('is-active'));
      if (!active || !this.isVisible(active)) this.showFirst();
    }
    currentIndex(list) {
      const active = this.messages.find((m) => m.classList.contains('is-active'));
      const idx = list.indexOf(active);
      return idx < 0 ? 0 : idx;
    }
    go(dir) {
      const list = this.visibleMessages();
      if (list.length < 2) return;
      let i = this.currentIndex(list) + dir;
      i = (i + list.length) % list.length;
      this.setActive(list[i]);
    }
    bindArrow(sel, dir) {
      const btn = this.querySelector(sel);
      if (!btn) return;
      btn.addEventListener('click', () => {
        this.go(dir);
        if (this.autoplay && !this.reduceMotion) { this.stop(); this.start(); }
      });
    }
    start() {
      this.stop();
      if (this.visibleMessages().length < 2) return;
      this.timer = setInterval(() => this.go(1), this.interval);
    }
    stop() {
      clearInterval(this.timer);
    }
  }
  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StoreHeader extends HTMLElement {
    connectedCallback() {
      // searchModal è renderizzato fuori da <store-header> (vedi commento nel markup): va cercato
      // a livello documento, non con this.querySelector. Il drawer mobile (#MobileMenu) è cablato
      // interamente da HendyMobileNav, non serve più un riferimento qui.
      this.searchModal = document.querySelector('[data-search-modal]');
      this.bind('[data-menu-open]', () => window.HendyMobileNav && window.HendyMobileNav.open(this));
      this.bind('[data-menu-close]', () => window.HendyMobileNav && window.HendyMobileNav.close(this), document.getElementById('MobileMenu'));
      this.bind('[data-search-open]', () => this.toggleSearch(true));
      // The drawer's own search button (#MobileMenu is rendered OUTSIDE <store-header> on purpose
      // — see the comment near its render call) is invisible to the query above, which is scoped
      // to `this`: without a second bind call it is wired to nothing. Close the drawer first so
      // the two full-screen overlays never stack (same choice as the header icon, which never has
      // the drawer open underneath it to begin with).
      this.bind('[data-search-open]', () => {
        if (window.HendyMobileNav) window.HendyMobileNav.close(this);
        this.toggleSearch(true);
      }, document.getElementById('MobileMenu'));
      this.bind('[data-search-close]', () => this.toggleSearch(false), this.searchModal);
      this.bind('[data-cart-open]');
      this._onKeydown = (e) => {
        if (e.key === 'Escape') { this.toggleSearch(false); }
      };
      document.addEventListener('keydown', this._onKeydown);
      if (this.dataset.sticky === 'true') this.initSticky();
      if (window.HendyMegaMenu) {
        window.HendyMegaMenu.init(this);
        if (window.HendyMobileNav) window.HendyMobileNav.init(this);
      } else {
        // Lo script del componente ha `defer`: se non è ancora eseguito, riprova a DOM pronto.
        // init() è idempotente, quindi una doppia chiamata è innocua.
        document.addEventListener('DOMContentLoaded', () => {
          if (window.HendyMegaMenu) window.HendyMegaMenu.init(this);
          if (window.HendyMobileNav) window.HendyMobileNav.init(this);
        }, { once: true });
      }
    }
    disconnectedCallback() {
      if (window.HendyMegaMenu) window.HendyMegaMenu.destroy(this);
      if (window.HendyMobileNav) window.HendyMobileNav.destroy(this);
      document.removeEventListener('keydown', this._onKeydown);
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }
    bind(sel, fn, root) {
      const scope = root === undefined ? this : root;
      if (!scope) return;
      scope.querySelectorAll(sel).forEach((el) => el.addEventListener('click', (e) => {
        // Icona carrello: apre il drawer se presente, altrimenti lascia navigare il link a /cart
        // (fallback no-JS o cart_type "page"). Il branch esce prima di fn(), quindi il bind di
        // [data-cart-open] può essere registrato senza callback.
        if (el.tagName === 'A' && el.hasAttribute('data-cart-open')) {
          if (document.querySelector('cart-drawer')) {
            e.preventDefault();
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
          return;
        }
        e.preventDefault();
        if (fn) fn();
      }));
    }
    toggleSearch(open) {
      if (!this.searchModal) return;
      // Two triggers can open the same modal (header icon inside <store-header>, drawer icon
      // inside #MobileMenu outside it): sync aria-expanded on every one of them, not just
      // whichever lives under `this`.
      document.querySelectorAll('[data-search-open]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (open) {
        this._searchOpener = document.activeElement;
        clearTimeout(this._searchHideTimer);
        // Render first (remove [hidden]) allo stato chiuso, forza un reflow, poi aggiungi .is-open
        // al frame successivo così la transizione di apertura parte davvero (come toggleMobile).
        this.searchModal.hidden = false;
        this.searchModal.getBoundingClientRect();
        this._searchOpenRaf = requestAnimationFrame(() => {
          if (!this.searchModal.hidden) this.searchModal.classList.add('is-open');
        });
        const input = this.searchModal.querySelector('input[type="search"]');
        if (input) setTimeout(() => input.focus(), 50);
      } else {
        cancelAnimationFrame(this._searchOpenRaf);
        this.searchModal.classList.remove('is-open');
        // Keep it in the DOM until the fade-out finishes, then hide it. The delay must stay
        // longer than --duration-medium; don't shorten it without checking that token's value.
        this._searchHideTimer = setTimeout(() => { this.searchModal.hidden = true; }, 360);
        if (this._searchOpener) this._searchOpener.focus();
      }
    }
    initSticky() {
      var wrapper = this.closest('.shopify-section') || this;
      wrapper.classList.add('header-section--sticky');
      // Il wrapper sticky dipinge lo sfondo al posto del figlio (vedi commento CSS: WebKit
      // sticky-descendant paint bug). Le CSS var inline vivono su <store-header> e scendono, non
      // risalgono: le copiamo sul wrapper risolvendo i fallback dallo stile calcolato del FIGLIO
      // (che porta la classe .color-* → i valori dello schema colori).
      var cs = getComputedStyle(this);
      var bgInitial = this.style.getPropertyValue('--header-bg-initial').trim() || cs.getPropertyValue('--color-background').trim();
      var bgScrolled = this.style.getPropertyValue('--header-bg-scrolled').trim() || cs.getPropertyValue('--color-primary').trim();
      if (bgInitial) wrapper.style.setProperty('--header-bg-initial', bgInitial);
      if (bgScrolled) wrapper.style.setProperty('--header-bg-scrolled', bgScrolled);
      var late = this.dataset.stickyBehavior === 'after-scroll';
      if (late) {
        wrapper.classList.add('header-section--late');
        wrapper.style.setProperty('--header-h', this.offsetHeight + 'px');
      }
      var self = this;
      var syncOffsets = function () {
        // Le ancore in pagina non devono finire sotto l'header fisso.
        document.documentElement.style.scrollPaddingTop = (self.offsetHeight + 12) + 'px';
        if (late) wrapper.style.setProperty('--header-h', self.offsetHeight + 'px');
      };
      this._onScroll = function () {
        var y = window.scrollY;
        self.classList.toggle('is-scrolled', y > 10);
        wrapper.classList.toggle('is-scrolled', y > 10);
        if (late) wrapper.classList.toggle('is-shown', y > Math.max(240, self.offsetHeight * 2));
      };
      this._onResize = syncOffsets;
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      syncOffsets();
      this._onScroll(); // stato iniziale corretto anche se la pagina si apre già scrollata (ancora)
    }
  }
  if (!customElements.get('store-header')) {
    customElements.define('store-header', StoreHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroVideo extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      var video = this.querySelector('video');
      if (!video) return;
      if (this.dataset.autoplay !== 'true') return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || document.body.classList.contains('animations-off')) {
        video.setAttribute('controls', '');
        return;
      }
      video.muted = true;
      var played = video.play();
      if (played && played.catch) {
        played.catch(function () { video.setAttribute('controls', ''); });
      }
    }
  }
  class HeroVideoEmbed extends HTMLElement {
    connectedCallback() {
      var trigger = this.querySelector('[data-video-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', () => {
        var tpl = this.querySelector('[data-video-embed]');
        if (tpl) { this.innerHTML = ''; this.appendChild(tpl.content.cloneNode(true)); }
      });
    }
  }
  if (!customElements.get('hero-video')) { customElements.define('hero-video', HeroVideo); }
  if (!customElements.get('hero-video-embed')) { customElements.define('hero-video-embed', HeroVideoEmbed); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspots"] && !Shopify.designMode) return;
  try {
    
  class HotspotImage extends HTMLElement {
    connectedCallback() {
      this.points = Array.from(this.querySelectorAll('.hotspots__point'));
      this.points.forEach((point) => {
        var btn = point.querySelector('.hotspots__dot');
        btn.addEventListener('click', () => {
          var open = point.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          this.points.forEach((p) => { if (p !== point) p.classList.remove('is-open'); });
        });
      });
    }
  }
  if (!customElements.get('hotspot-image')) { customElements.define('hotspot-image', HotspotImage); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  class IwtVideo extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      var video = this.querySelector('video');
      if (!video) return;
      if (this.dataset.autoplay !== 'true') return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || document.body.classList.contains('animations-off')) {
        video.setAttribute('controls', '');
        return;
      }
      video.muted = true;
      var played = video.play();
      if (played && played.catch) {
        played.catch(function () { video.setAttribute('controls', ''); });
      }
    }
  }
  if (!customElements.get('iwt-video')) { customElements.define('iwt-video', IwtVideo); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var panel = document.querySelector('[data-filter-panel]');
      if (!panel) return;
      if (e.target.closest('[data-filter-open]')) { panel.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
      if (e.target.closest('[data-filter-close]')) { panel.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-recover-toggle]')) {
      e.preventDefault();
      var r = document.getElementById('recover');
      if (r) { r.hidden = !r.hidden; if (!r.hidden) r.scrollIntoView({ behavior: 'smooth' }); }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mattress-layers"] && !Shopify.designMode) return;
  try {
    
  class MattressLayers extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      if (this.getAttribute('data-mode') === 'accordion') {
        this.initAccordion();
      } else {
        this.initTabs();
      }
    }

    initTabs() {
      this.tabs = Array.from(this.querySelectorAll('.layers__item'));
      this.panels = Array.from(this.querySelectorAll('.layers__panel'));
      this.panelHost = this.querySelector('.layers__detail');
      // Below 990px the tabs/panel pair (.layers__grid) is display:none and the accordion
      // list is the only visible thing on screen -- see .layers__acc-list--tabs-mobile CSS.
      // Both lists are built from the same source (blocks/metaobjects) in the same order, so
      // index i in .layers__item always matches index i in .layers__acc.
      this.accItems = Array.from(this.querySelectorAll('.layers__acc'));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.activate(i, false));
        tab.addEventListener('keydown', (e) => this.onKey(e, i));
      });
      // Theme Editor: selecting a layer block activates its tab AND, since the tab itself has
      // no real geometry below 990px, opens the matching accordion item so there is always a
      // visible anchor for the selected block regardless of preview width.
      this.addEventListener('shopify:block:select', (e) => {
        const tab = e.target.closest && e.target.closest('.layers__item');
        if (!tab) return;
        const index = this.tabs.indexOf(tab);
        this.activate(index, false);
        const acc = this.accItems[index];
        if (acc) {
          acc._wasOpen = acc.open;
          acc.open = true;
        }
      });
      this.addEventListener('shopify:block:deselect', (e) => {
        const tab = e.target.closest && e.target.closest('.layers__item');
        if (!tab) return;
        const acc = this.accItems[this.tabs.indexOf(tab)];
        if (acc && !acc._wasOpen) acc.open = false;
      });
    }

    activate(index, focusTab) {
      if (index < 0 || index >= this.tabs.length) return;
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
      this.panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
      if (this.panelHost && this.tabs[index]) {
        this.panelHost.setAttribute('aria-labelledby', this.tabs[index].id);
      }
      if (focusTab && this.tabs[index]) this.tabs[index].focus();
    }

    onKey(e, i) {
      let next = null;
      switch (e.key) {
        case 'ArrowUp':
        case 'ArrowLeft':
          next = i - 1;
          break;
        case 'ArrowDown':
        case 'ArrowRight':
          next = i + 1;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = this.tabs.length - 1;
          break;
        default:
          return;
      }
      e.preventDefault();
      if (next < 0) next = this.tabs.length - 1;
      if (next >= this.tabs.length) next = 0;
      this.activate(next, true);
    }

    initAccordion() {
      // Panels animate through the shared <details data-accordion-group> handler in
      // global.js. Here we only bridge the Theme Editor: open the selected layer, and
      // restore it on deselect if it started closed.
      this.addEventListener('shopify:block:select', (e) => {
        const d = e.target.closest && e.target.closest('details.layers__acc');
        if (!d) return;
        d._wasOpen = d.open;
        d.open = true;
      });
      this.addEventListener('shopify:block:deselect', (e) => {
        const d = e.target.closest && e.target.closest('details.layers__acc');
        if (!d) return;
        if (!d._wasOpen) d.open = false;
      });
    }
  }
  if (!customElements.get('mattress-layers')) {
    customElements.define('mattress-layers', MattressLayers);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      var url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then((text) => {
          var html = new DOMParser().parseFromString(text, 'text/html');
          var fresh = html.querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim().length) {
            this.innerHTML = fresh.innerHTML;
            this.dataset.loaded = 'true';
          } else {
            this.hidden = true;
          }
        })
        .catch(() => { this.hidden = true; });
    }
  }
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (this._loaded) return;
      this._loaded = true;
      var track = this.querySelector('[data-track]');
      if (!track) return;
      var handles;
      try {
        handles = JSON.parse(localStorage.getItem('hendy:recently-viewed') || '[]');
      } catch (e) {
        handles = [];
      }
      var current = this.dataset.currentHandle;
      var max = parseInt(this.dataset.maxItems, 10) || 8;
      handles = handles.filter(function (h) { return h && h !== current; }).slice(0, max);
      if (!handles.length) return;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var self = this;
      Promise.all(handles.map(function (handle) {
        return fetch(root + 'products/' + handle + '?view=card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (results) {
        var html = results.join('');
        if (!html.trim()) return;
        track.innerHTML = html;
        self.hidden = false;
        var slider = self.querySelector('carousel-slider');
        if (slider && typeof slider.init === 'function') slider.init();
      });
    }
  }
  if (!customElements.get('recently-viewed')) {
    customElements.define('recently-viewed', RecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    
  class VideoPlayer extends HTMLElement {
    connectedCallback() {
      var trigger = this.querySelector('[data-video-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', () => {
        var tpl = this.querySelector('[data-video-embed]');
        if (tpl) { this.innerHTML = ''; this.appendChild(tpl.content.cloneNode(true)); }
      });
    }
  }
  if (!customElements.get('video-player')) { customElements.define('video-player', VideoPlayer); }

  } catch(e) { console.error(e); }
})();
})();
